module.exports = __webpack_public_path__ + "resources/img/equipment_tab_img3_m.775f8908aaaf630ec4e22589876ea2a5.jpg";